import * as React from "react";
import { Badge, Col, Row } from "reactstrap";

import { ContentQuestionRow } from "../../common/contentTypes";

/**
 * The row expander. A raw JSON dump — the table's default — is unreadable when
 * what you actually need is to check an answer key, so this lays the question
 * out the way it reads: full title, the four choices side by side with the
 * correct one marked, then the metadata that decides whether it serves.
 */
export const QuestionDetail: React.FC<{
  question: ContentQuestionRow;
  /** Readable `Group:Name`; falls back to the raw id if unresolved. */
  categoryLabel?: string;
}> = ({ question, categoryLabel }) => (
  <div className="py-2 text-left">
    <Row className="align-items-start">
      <Col>
        <h5 className="mb-3">{question.title}</h5>
      </Col>
      <Col xs="auto">
        <small className="text-muted">{question.id}</small>
      </Col>
    </Row>

    <Row>
      {question.choices.map((choice) => (
        <Col md={6} key={choice.id || choice.label} className="mb-2">
          <div
            className={`px-2 py-1 rounded ${
              choice.correct ? "bg-success-subtle border border-success" : ""
            }`}
            style={
              choice.correct
                ? { backgroundColor: "#d4edda", borderColor: "#c3e6cb" }
                : undefined
            }
          >
            {choice.correct && <i className="fas fa-check text-success mr-2" />}
            {choice.label}
          </div>
        </Col>
      ))}
    </Row>

    <div className="mt-2">
      <Badge color="secondary" className="mr-1">
        {categoryLabel ?? question.categoryId}
      </Badge>
      <Badge color="secondary" className="mr-1">
        difficulty: {question.difficulty}
      </Badge>
      <Badge color="secondary" className="mr-1">
        state: {question.state}
      </Badge>
      {question.reviewStatus && (
        <Badge color="secondary" className="mr-1">
          review: {question.reviewStatus}
        </Badge>
      )}
      {question.source?.kind && (
        <Badge color="secondary" className="mr-1">
          source: {question.source.kind}
        </Badge>
      )}
    </div>
  </div>
);
